<template>
  <div class="reflections-view">
    <router-view class="pa-0" />
  </div>
</template>

<script>
import { types } from '@/store/rootTypes';
import { mapActions } from 'vuex';

export default {
  name: 'ReflectionView',
  data() {
    return {
      lastReflectionId: 'none',
    };
  },
  beforeMount() {
    this.updateSnapshotById();
  },
  beforeUpdate() {
    console.log('Updating reflection view', this.$route.params.reflectionId);
    this.updateSnapshotById();
  },
  beforeDestroy() {
    this.unsubscribeReflection();
  },
  methods: {
    ...mapActions({
      fetchReflection: types.reflections.actions.fetchReflection,
      unsubscribeReflection: types.reflections.actions.unsubscribeReflection,
    }),
    updateSnapshotById() {
      const { params } = this.$route;
      const { reflectionId } = params || {};

      // TODO make sure we unsubscribe properly when changing reflection
      if (!reflectionId && this.lastReflectionId !== 'none') {
        this.unsubscribeReflection();
        this.lastReflectionId = 'none';
      } else if (reflectionId && this.lastReflectionId !== reflectionId) {
        this.fetchReflection({ reflectionId });
        this.lastReflectionId = reflectionId;
      }
    },
  },
};
</script>

<style>
.reflections-view {
  height: 100%;
  width: 100%;
  min-width: 1497px;
}
</style>
